import styled from 'styled-components';
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-1jjfc3v-0"
})(["min-height:300px;padding:7px 9px;margin:20px auto 16px;"]);
export var Title = styled.div.withConfig({
  displayName: "partials__Title",
  componentId: "sc-1jjfc3v-1"
})(["margin-bottom:32px;text-align:center;"]);
var ContentSize = {
  small: '320px',
  large: '100%'
};
export var Content = styled.div.withConfig({
  displayName: "partials__Content",
  componentId: "sc-1jjfc3v-2"
})(["overflow-y:auto;", ""], function (_ref) {
  var size = _ref.size;
  return "\n    max-height: ".concat(ContentSize[size], ";\n  ");
});
export var EmptyContentInner = styled.div.withConfig({
  displayName: "partials__EmptyContentInner",
  componentId: "sc-1jjfc3v-3"
})(["color:", ";text-align:center;svg{margin:36px auto 42px;}p{margin:0 auto;}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.fontL;
});